/*
 * DR Vitamin — result handling for «نبهني عند التوفر» and «اطلب توفيره» (2026-09-14).
 *
 * The fields live inside the product form but belong to the contact forms rendered after it (see
 * snippets/drv-oos-forms-host.liquid). After a submission Shopify returns to the product page with
 * ?contact_posted=true#<form id>, which is how the right widget is found. The page never claims success
 * unless Shopify said so. Nothing here reads or reveals stock.
 */
(function () {
  var DEMAND_KEY = 'drv.demand.sent.';
  function store(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function widgetFor(id) { return document.querySelector('[data-drv-widget="' + id + '"]'); }

  function showResult(id, ok, errorText) {
    var w = widgetFor(id); if (!w) return;
    var d = w.closest('details') || w.querySelector('details'); if (d) d.open = true;
    var fields = w.querySelector('[data-drv-fields]'), okEl = w.querySelector('[data-drv-ok]'), errEl = w.querySelector('[data-drv-err]');
    if (ok) {
      if (fields) fields.hidden = true;
      if (okEl) okEl.hidden = false;
      var sku = w.getAttribute('data-sku');
      if (id === 'drv-demand-form' && sku) store(false, DEMAND_KEY + sku, new Date().toISOString().slice(0, 10));
      /* 2026-09-18: a SIGNED-IN customer's confirmed back-in-stock request is remembered for that customer, so the
         account page (/pages/me → notifications) can show it with the product's live availability. Only after Shopify
         confirmed the submission; one entry per variant; never for guests (they get the email only). */
      var cust = window.theme && window.theme.customer && window.theme.customer.id;
      if (id === 'drv-notify-form' && cust && w.getAttribute('data-handle')) {
        var k = 'drv.bis.' + cust, list = [];
        try { list = JSON.parse(store(true, k) || '[]') || []; } catch (e) { list = []; }
        var v = w.getAttribute('data-variant');
        list = list.filter(function (x) { return String(x.v) !== String(v); });
        list.push({ v: v, h: w.getAttribute('data-handle'), d: new Date().toISOString().slice(0, 10) });
        store(false, k, JSON.stringify(list.slice(-20)));
      }
    } else if (errorText && errEl) {
      errEl.textContent = errorText; errEl.hidden = false;
    }
    if (d) setTimeout(function () { d.scrollIntoView({ block: 'center' }); }, 60);
  }

  function init() {
    var hash = location.hash.replace('#', '');
    var posted = /[?&]contact_posted=true(&|$)/.test(location.search);
    var hosts = document.querySelectorAll('[data-drv-host]');
    for (var i = 0; i < hosts.length; i++) {
      var id = hosts[i].getAttribute('data-drv-host');
      if (hash !== id) continue;
      var errors = hosts[i].getAttribute('data-errors');
      if (posted && !errors) showResult(id, true); else if (errors) showResult(id, false, errors);
    }
    /* one request per product per device is enough: say so instead of silently accepting duplicates */
    var dw = widgetFor('drv-demand-form');
    if (dw && dw.getAttribute('data-sku') && store(true, DEMAND_KEY + dw.getAttribute('data-sku'))) {
      var note = dw.querySelector('[data-drv-already]'); if (note && dw.querySelector('[data-drv-ok]').hidden) note.hidden = false;
    }
    /* Shopify protects contact forms with hCaptcha and attaches it only after a focusin/change inside the form.
       A signed-in customer's one-tap request has no field to focus, so the submit would be held forever. Opening
       the panel therefore announces a focusin on the form's own submit button, which lets Shopify attach its
       captcha early (it is loaded and shown by Shopify; nothing is bypassed). */
    var panels = document.querySelectorAll('[data-drv-widget] details');
    for (var p = 0; p < panels.length; p++) {
      panels[p].addEventListener('toggle', function (e) {
        if (!e.currentTarget.open) return;
        var w = e.currentTarget.closest('[data-drv-widget]');
        var b = w && document.querySelector('button[form="' + w.getAttribute('data-drv-widget') + '"]');
        if (b) b.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      });
    }
    /* no double submission */
    ['drv-notify-form', 'drv-demand-form'].forEach(function (fid) {
      var f = document.getElementById(fid); if (!f || f.__drv) return; f.__drv = true;
      f.addEventListener('submit', function () {
        var btn = document.querySelector('button[form="' + fid + '"]');
        if (btn) setTimeout(function () { btn.disabled = true; }, 0);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
